import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import CitysparkEvents from '../../UIElements/CitysparkEvents/CitysparkEvents.mjs';
import styled from 'styled-components';

const StyledN12Events = styled(CitysparkEvents) `
  .csBottomLinks {
    .csBtn:last-of-type {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
`;
const StyledN12FlexContainer = styled(FlexContainer) `
  position: relative;
`;

export { StyledN12Events, StyledN12FlexContainer };
//# sourceMappingURL=N12Events.styles.mjs.map
